import { QrGateway } from '../model/qrGateway';
import { QrGatewayEntity } from './qrGatewayEntity';

export const QrGatewayListValueObject = (data: QrGateway[]) => {
  return Object.freeze({
    list: data.map((item) => QrGatewayEntity(item)),
  });
};
